export default __webpack_public_path__ + "media/images/avatars/avatar22-584ee0729f83dd3012eb4f128a3aeb0b.png";